import React from 'react';
import BreakpointProvider from '../../components/BreakpointProvider/BreakpointProvider';
import SwitchTestProvider from '../../components/SwitchTestProvider/SwitchTestProvider';
import ProductPageContent from './ProductPageContent';
import BrowserProvider from '../../components/BrowserProvider/BrowserProvider';

export default function ProductPage({
  collectionId, productId, categoryId, faceout, store, storeId, currency,
}) {
  return (
    <SwitchTestProvider>
      <BrowserProvider>
        <BreakpointProvider>
          <ProductPageContent
            collectionId={collectionId}
            productId={productId}
            categoryId={categoryId}
            faceout={faceout}
            store={store}
            storeId={storeId}
            currency={currency}
          />
        </BreakpointProvider>
      </BrowserProvider>
    </SwitchTestProvider>
  );
}
